import { render, staticRenderFns } from "./aiCustomPageVisualizationView.vue?vue&type=template&id=0aa38bc0&scoped=true&"
import script from "./aiCustomPageVisualizationView.vue?vue&type=script&lang=js&"
export * from "./aiCustomPageVisualizationView.vue?vue&type=script&lang=js&"
import style0 from "./aiCustomPageVisualizationView.vue?vue&type=style&index=0&id=0aa38bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa38bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0aa38bc0')) {
      api.createRecord('0aa38bc0', component.options)
    } else {
      api.reload('0aa38bc0', component.options)
    }
    module.hot.accept("./aiCustomPageVisualizationView.vue?vue&type=template&id=0aa38bc0&scoped=true&", function () {
      api.rerender('0aa38bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/aiCustomPage/aiCustomPageVisualizationView.vue"
export default component.exports